// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/chokhmah.scss
// module id = ./scss/chokhmah.scss
// module chunks = 0